export default __webpack_public_path__ + "static/media/profile-search.d5744a6e.svg";